import React from 'react';
import Styles from '../../assets/css/components/itemRegistration/itemRegistration.module.scss';
import ProductList from '../../pages/ProductList';
import { useNavigate } from 'react-router-dom';

const ItemRegistration = () => {
    const navigate = useNavigate();

    const handleAddProduct = () => {
        navigate("/scanbarcode", {
            state: {
                scanType: "inbound",
                autoOpenScanner: true,
                fromItemRegistration: true 
            }
        });
    };

    return (
        <div className={`${Styles.registration}`}>
            <div className={`${Styles.registration_heading}`}>
                <h2>Product List</h2>
                <button 
                    className={`${Styles.add_btn}`} 
                    onClick={handleAddProduct}
                >
                    Add Product
                </button>
                {/* <button className={`${Styles.add_btn}`} onClick={() => navigate("/scanbarcode", {state: "addProductRoute"})}>Add Product</button> */}
            </div>

            <div>
                <ProductList />
            </div>
        </div>
    )
}

export default ItemRegistration
